<template>
  <div :class="`form-element form-${type}-element`">
    <img :src="options.src.file_url">
  </div>
</template>

<script>
export default {
  props: {
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
}
</style>
